import { render } from "./fzhsDetailAccount.vue?vue&type=template&id=5bf3b406&scoped=true"
import script from "./fzhsDetailAccount.vue?vue&type=script&lang=js"
export * from "./fzhsDetailAccount.vue?vue&type=script&lang=js"

import "./fzhsDetailAccount.vue?vue&type=style&index=0&id=5bf3b406&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf3b406"]])

export default __exports__